module.exports = __webpack_public_path__ + "img/error-img.2e3d44d5.png";